import React from "react";
import WPDropdown from "../../packages/WPDropdown";
import { getControlId } from "../../utils/Utils";

const Dropdown = (props) => {
  let {
    value,
    options,
    getOptionLabel,
    disabled,
    onChange,
    placeholder,
    errorMsg,
    labelText,
    customClass,
    ismultiple,
    groupBy,
    getOptionSelected,
    dropdownRef,
    isRequired,
    showCancelIcon = false,
  } = props;

  customClass = customClass || "";
  let dropdownOptions = options || [];
  // Transform primitive options to { label, value } objects for WPDropdown
  if (
    dropdownOptions.length > 0 &&
    (typeof dropdownOptions[0] === "string" ||
      typeof dropdownOptions[0] === "number")
  ) {
    dropdownOptions = dropdownOptions.map((opt) => ({
      label: String(opt),
      value: opt,
    }));
  }

  // Transform primitive value to { label, value } object for WPDropdown
  const dropdownValue = value
    ? typeof value === "string" || typeof value === "number"
      ? { label: String(value), value: value }
      : value
    : null;

  const dropdownId = getControlId(labelText, "dropdown");

  const handleChange = (selectedOption, name) => {
    if (ismultiple) {
      // For multi-select, return array of values
      const values = selectedOption
        ? selectedOption.map((option) => option.value)
        : [];
      onChange(values, name);
    } else {
      // For single select, return just the value
      const value = selectedOption ? selectedOption.value : null;
      onChange(value, name);
    }
  };

  return (
    <div className={customClass}>
      <WPDropdown
        id={dropdownId}
        name={dropdownId}
        value={dropdownValue}
        label={labelText}
        options={dropdownOptions}
        getOptionLabel={getOptionLabel}
        onChange={handleChange}
        isMulti={ismultiple}
        disabled={disabled}
        placeholder={placeholder}
        isError={Boolean(errorMsg)}
        helperText={errorMsg}
        tabIndex={0}
        formatGroupLabel={groupBy}
        getOptionValue={getOptionSelected}
        ref={dropdownRef}
        required={isRequired}
        showCancelIcon={showCancelIcon}
      />
    </div>
  );
};

export default Dropdown;
